// extracted by mini-css-extract-plugin
module.exports = {"ConfirmModalContainer":"reject-confirm-modal_ConfirmModalContainer__fzW6O","Title":"reject-confirm-modal_Title__jFT5C"};